import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

/**
 * Zapas ważności wymuszany przed wysłaniem żądania. Musi pokrywać czas przetwarzania na serwerze,
 * bo szprot-server forwarduje ten sam token dalej (m.in. do Keycloak Admin API) długo po tym,
 * jak Spring Security go zwalidował.
 */
const TOKEN_MIN_VALIDITY_SECONDS = 70;

@Injectable()
export class KeycloakAuthInterceptor implements HttpInterceptor {

    private loginRedirectStarted = false;

    constructor(private keycloakService: KeycloakService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('assets/'))
            return next.handle(req);

        return from(this.keycloakService.updateToken(TOKEN_MIN_VALIDITY_SECONDS)).pipe(
            catchError((error: unknown) => this.redirectToLogin(error)),
            mergeMap(() => next.handle(this.withBearer(req)).pipe(
                catchError((error: unknown) => this.retryOnceIfUnauthorized(req, next, error))
            ))
        );
    }

    private retryOnceIfUnauthorized(req: HttpRequest<any>, next: HttpHandler, error: unknown): Observable<HttpEvent<any>> {
        if (!(error instanceof HttpErrorResponse) || error.status != 401)
            return throwError(error);

        return from(this.keycloakService.updateToken(-1)).pipe(
            catchError((refreshError: unknown) => this.redirectToLogin(refreshError)),
            mergeMap(() => next.handle(this.withBearer(req)))
        );
    }

    private withBearer(req: HttpRequest<any>): HttpRequest<any> {
        return req.clone({
            setHeaders: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                Authorization: `Bearer ${this.keycloakService.getKeycloakInstance().token}`
            }
        });
    }

    private redirectToLogin(error: unknown): Observable<never> {
        if (!this.loginRedirectStarted) {
            this.loginRedirectStarted = true;
            void this.keycloakService.login({ redirectUri: window.location.href });
        }
        return throwError(error);
    }

}
